import { getTestIds } from 'seagull/utils/TestIds';
export const createClientModalTextsPath = 'components.createClientModal';
export const CLIENT_DETAILS_FORM_TEST_ID = 'create-client-details';
export const CONTACT_FORM_TEST_ID = (index)=>"create-client-contact-".concat(index);
export const CONTACTS_FIELD_NAME = 'contacts';
export const GetCreateClientModalTID = (parentTestId)=>getTestIds(parentTestId);
